import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const isoModule = {
  namespaced: true,
  state() {
    return { isoNames: [], isoGrades: [], isoValues: [] };
  },
  actions,
  getters,
  mutations,
};

export default isoModule;
